var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58335 18C11.3524 18 12.9787 17.365 14.2763 16.312L18.4891 20.708L19.8442 19.294L15.6314 14.898C16.6415 13.543 17.25 11.846 17.25 10C17.25 5.589 13.8106 2 9.58335 2C5.35615 2 1.91669 5.589 1.91669 10C1.91669 14.411 5.35615 18 9.58335 18ZM9.58335 4C12.7545 4 15.3334 6.691 15.3334 10C15.3334 13.309 12.7545 16 9.58335 16C6.41223 16 3.83335 13.309 3.83335 10C3.83335 6.691 6.41223 4 9.58335 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9365 8.58603C11.2997 8.96603 11.5 9.46802 11.5 10H13.4166C13.4166 8.93502 13.018 7.93102 12.2916 7.17202C10.8406 5.66002 8.32502 5.66002 6.87506 7.17202L8.22823 8.58803C8.95656 7.83003 10.212 7.83203 10.9365 8.58603Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.5a31f09caaa0efb4ef724407b9205716.svg";
export { ForwardRef as ReactComponent };